import isEpicPlan from '../isEpicPlan'

function getCustom(period, options: GetPeriodOptions): string {
  const isEpic = options.plan ? isEpicPlan(options.plan) : false

  if (options.stateAcronym === 'ND' && period === 360 && (isEpic || !options.plan)) {
    return '2x180'
  }
}

function getExtended(policy, period, options: GetPeriodOptions) {
  const extendedDuration = options.extendedDuration ? options.extendedDuration : policy

  if (extendedDuration && policy > 1) {
    return extendedDuration === period
      ? `${policy}x${period}`
      : `${period}+${extendedDuration}`
  }
}

function getDefault(policy, period, options: GetPeriodOptions): string {
  const omitSinglePolicy =
    options.omitSinglePolicy !== undefined ? options.omitSinglePolicy : false
  return !omitSinglePolicy ? `${policy}x${period}` : period.toString()
}

function getExtendedLabel(policy, period, options: GetPeriodOptions) {
  const extendedDuration = options.extendedDuration || period
  const currentPolicy = policy
  const maxPolicies = options.maxPolicy || policy

  if (extendedDuration && currentPolicy > 1) {
    if (extendedDuration !== period) {
      return `${period} + ${extendedDuration}`
    }
    return `${maxPolicies > 1 ? maxPolicies + 'x' : ''}${period}`
  }

  return period
}

function getPeriodId(policy, period, options: GetPeriodOptions): string {
  options = options || {}

  return (
    getCustom(period, options) ||
    getExtended(policy, period, options) ||
    getDefault(policy, period, options)
  )
}

function getPeriodAsLabel(policy, period, options: GetPeriodOptions): string {
  options = options || {}

  return getCustom(period, options) || getExtendedLabel(policy, period, options)
}

export { getPeriodAsLabel, getCustom }
export default getPeriodId
